import $ from "jquery";

const woocoomercePagination = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      section: ".js-woo-pagination",
      wooPaginationThemify:
        ".js-woo-pagination .wpf-pagination .woocommerce-pagination",
      wooPagination:
        ".js-woo-pagination .woocommerce > .woocommerce-pagination",
    };

    if ($(el.section).length === 0) {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("wpf")) {
      $(el.wooPaginationThemify).css("display", "none");
    }
  };

  init();
};

try {
  woocoomercePagination();
} catch (error) {
  console.error("woocoomercePagination", error);
}
